module.exports = __webpack_public_path__ + "static/media/cover.06efb396.jpg";